<template>
  <div class="videos">
    <top-header></top-header>

    <div class="collection-page--outer-wrapper marginBrandname" >

      <b-container >
        <!--<span class="product-txt d-block text-center" style="padding-top: 50px;text-transform: uppercase;margin-bottom:12px;">Videos</span> -->
		
		<b-row style="padding-top:60px;padding-bottom: 21px;">
			<b-col class="p-0">
        <div class=" d-block text-center" style="padding:7px;text-transform:uppercase;box-shadow: 1px 3px #c6c6c6; background: #c6c6c630;font-size: 25px;"> <span v-if="videosCatname!=''">{{videosCatname}} Videos</span><span v-else>Promote Properties</span></div>
		</b-col>
		</b-row>
		  <b-row>
		  <b-col cols="12" lg="2" md="2" sm="12" class="p-0  videosList filterPael "  >
						
						<div  class="leftPanel  nav mobilfilter" id="filterlist" :class="[{'mobilfilterlist' : mobilfilterlist}]">
								<b-container fluid class="d-md-none applyPaneltop">
								  <b-row>
									<b-col cols="6" class="filtebrack">
									<b-link @click="mobilfilterlist=0"><i class="fa fa-angle-left"></i>
									<span>Filters</span></b-link>
									</b-col>
									<b-col class="applyBtn" cols="6">
										<b-link @click="mobilfilterlist=0" class="btnapply"></b-link>
									</b-col>
								   </b-row>
								   </b-container>
									<b-list-group flush class="scrollBrand scrollBrandHeight widthInVV" >
										<b-list-group-item style="padding:2px;"  v-if="filterCat==0">
												<b-list-group class="clgi">
												  <b-list-group-item href="/videos" active>Home</b-list-group-item>
												  <b-list-group-item href="#" @click="filter_catId=vcat.catId,filter_brandId='',videosCatname=vcat.catName,getMyvideo(),$event.target.classList.toggle('activec')" :class="{ activec : filter_catId == vcat.catId }"  :key="vcat.catId" v-for="vcat in videoCategory">{{vcat.catName}}</b-list-group-item>
												</b-list-group>
										</b-list-group-item>
										<b-list-group-item style="padding:2px;" v-if="filterBrand==0">
												<b-list-group class="clgi">
												  <b-list-group-item href="#" @click="filter_catId='',filter_brandId='',getMyvideo()" active>All Brands</b-list-group-item>
												  <b-list-group-item href="#" @click="filter_catId='',filter_brandId=brnd.brandId,getMyvideo()"  :key="brnd.brandId" v-for="brnd in brandList" :class="{ activeb : filter_brandId == brnd.brandId }" >{{brnd.brand_name}} </b-list-group-item>
												  
												</b-list-group>
										</b-list-group-item>								  
									</b-list-group>
									
				
				
						
						</div>


				
				</b-col>
			<b-col cols="12" lg="7" md="7" sm="12"> 
				<b-row>
					<b-col>
						<!--<b-embed
						type="iframe"
						aspect="16by9"
						src="https://www.youtube.com/embed/zpOULjyy-n8?rel=0"
						allowfullscreen
						></b-embed> -->
						<!--<video class="videoPlay" controls autoplay id="videoPlaySource" src="https://www.zoylu.com/uploads/post/video__81407.mp4"></video>-->
						<video class="videoPlay" controls autoplay id="videoPlaySource" :src="$root.MEDIAPATH+'videos/'+videoPlay.video_url"></video>
						<h4>{{videoPlay.title}}</h4>
						<b-row class="m-0" style="border: 1px solid #c6c6c670;padding: 5px;">
							<b-col> <b-button pill type="button"  v-b-toggle.cartPanel size="sm" :href="'/category/'+buynow" target="_blank">Buy Now</b-button>
							
							
							</b-col>
							<b-col>{{totalView|0}} Views | <b-link @click="likeVideo()"><i class="fa fa-thumbs-up"></i></b-link> <span>{{totalLike|0}}</span></b-col>
							<b-col cols="12" lg="4" md="4" sm="12">
							<div style="font-size: 18px;padding:0px;float:right;" class="jssocials shareIcon">
								<div style="float: left;margin-right: 18px; font-size: 23px;margin-top: -4px;">
								<i class="fa fa-share shareI"></i></div>
								
								
								<div class="jssocials-share jssocials-share-facebook ssic" >
								
								<ShareNetwork
										network="facebook"
										:url="'https://www.alluraa.com/videos/'+videoPlay.id"
										title="Alluraa Seller videos"
										description="Alluraa Seller videos"
										hashtags="Alluraa,Videos,sellerVideos"
										:quote="'Seller videos https://www.alluraa.com/videos/'+videoUrib64(videoPlay.id)"
										>
										<i class="fa fa-facebook jssocials-share-logo fb"></i>
									</ShareNetwork>
								
								</div>
								<div class="jssocials-share jssocials-share-twitter ssic" >
								
								<ShareNetwork
										network="twitter"
										:url="'https://www.alluraa.com/videos/'+videoUrib64(videoPlay.id)"
										title="Alluraa Seller Videos."
										hashtags="Alluraa,Videos,sellerVideos"
										twitter-user=""
										>
										<i class="fa fa-twitter jssocials-share-logo tw"></i>
									</ShareNetwork>
								</div>
								<!--<div class="jssocials-share jssocials-share-linkedin" style="float: left;margin-right: 10px;"><a href="#" class="jssocials-share-link"><i class="fa fa-linkedin jssocials-share-logo"></i></a></div> -->
								<div class="jssocials-share jssocials-share-whatsapp ssic" >
								<ShareNetwork
										network="whatsapp"
										:url="'https://www.alluraa.com/videos/'+videoUrib64(videoPlay.id)"
										title="Alluraa Seller Videos"
										description="Alluraa Seller Videos"
										 >
										<i class="fa fa-whatsapp jssocials-share-logo wh"></i>
									</ShareNetwork>
								
								</div>
							
							</div>
							</b-col>
						
						</b-row>
					</b-col>
					
				</b-row>
				<b-row>
					<b-col>
						<div class="all-products--wrapper d-flex flex-wrap justify-content-between pt-4 pl-0"  >
						
						
						
						  <div v-for="product in videoList" :key="product.id" 
							class="vldl pb-4" >
							<!--<span class="product-title d-block"><a :href="'/product/'+product.product_id">{{product.title}}</a></span> -->
							<b-link :href="'/videos/'+videoUrib64(product.id)">
								<b-row>						
									<b-col>
										<!--<b-embed
										type="iframe"
										aspect="16by9"
										src="https://www.youtube.com/embed/zpOULjyy-n8?rel=0"
										allowfullscreen
										></b-embed>-->
										<video class="vdmList" :id="'videoPlaySource'+product.id" :src="$root.MEDIAPATH+'videos/'+product.video_url"></video>
										<h6 class="mb-1 mt-2 text-truncate" style="font-size:13px;">{{product.title}}</h6>							
											<p class="mb-1 p-0 text-truncate" style="line-height: initial;font-size:14px;">
											<small>{{product.message}}</small>
											</p>
									</b-col>
								</b-row>
								</b-link>
						  </div>
						  
								<div v-if="videoList.length<1" style="width: 100%; margin-top:18%;">
								<div class="product--wrapperno d-flex flex-column align-items-center" >
								<span class="product-title d-block">No video available. Please check back later.</span>
								</div>
								</div>
						  <!--<div v-if="products.length%3>0" data-v-eedc78cc="" class=" d-flex flex-column align-items-center" style="width: 255px;">
							</div> -->
							<transition name="fade">
								<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
									<b-spinner label="Busy" variant="light"></b-spinner>
								</b-row>
							</transition>
						</div>

					
					
					
						
					</b-col>
				</b-row>
			
			
		  
		  
		  
		  </b-col>
			<b-col cols="12" lg="3" md="3" sm="12" class="p-0">
				<b-container fluid class="p-0 " > <!-- panelright -->
		
					<b-tabs content-class="mt-3" fill pills  class="profileTab">
						<b-tab title="Latest" active>
							<!-- <profile-account :profile="profile"></profile-account>-->
							
							<b-list-group flush>
							  <b-list-group-item v-for="itemV in videoLatest" :key="itemV.id" :href="'/videos/'+videoUrib64(itemV.id)" >
									<b-row>
										<b-col cols="4" class="p-0"> 
											<!--<b-embed
											type="iframe"
											aspect="16by9"
											src="https://www.youtube.com/embed/zpOULjyy-n8?rel=0"
											allowfullscreen
											></b-embed> -->
											<video class="vdlList" :id="'LatestSource'+itemV.id" :src="$root.MEDIAPATH+'videos/'+itemV.video_url"></video>
											
										</b-col>
										<b-col>
											<h5 class="mb-1" style="font-size: 13px;">{{itemV.title}}</h5>
											
												<p class="mb-1 p-0" style="line-height: initial;font-size:14px;">
												<small>{{itemV.message}}</small>
												</p>
										</b-col>
									</b-row>
							  </b-list-group-item>
							  
							</b-list-group>
							<!--<div class="card mb-3 flex-row">
							
								<b-embed
								type="iframe"
								aspect="16by9"
								src="https://www.youtube.com/embed/zpOULjyy-n8?rel=0"
								allowfullscreen
								></b-embed>
								
								<div class="card-body">
									
									<p style="font-size: 13px;"> Header and footers using props.</p>
									<b-card-text style="font-size: 13px;">  Some quick example text to build on the card and make up the bulk of the card's content. </b-card-text>
									
									
								</div>
							</div>-->
						</b-tab>

						<b-tab title="Most Viewed" >
							<b-list-group flush>
							  <b-list-group-item v-for="itemV in videoViewed" :key="itemV.id" :href="'/videos/'+videoUrib64(itemV.id)" >
									<b-row>
										<b-col cols="4" class="p-0"> 
											<video class="vdlList" :id="'mvSource'+itemV.id" :src="$root.MEDIAPATH+'videos/'+itemV.video_url"></video>
										</b-col>
										<b-col>
											<h5 class="mb-1" style="font-size: 13px;">{{itemV.title}}</h5>
											
												<p class="mb-1 p-0" style="line-height: initial;font-size:14px;">
												<small>{{itemV.message}}</small>
												</p>
										</b-col>
									</b-row>
							  </b-list-group-item>
							  
							</b-list-group>
						</b-tab>
						<b-tab title="Most Liked">
								<b-list-group flush>
								  <b-list-group-item v-for="itemV in videoLikes" :key="itemV.id" :href="'/videos/'+videoUrib64(itemV.id)" >
										<b-row>
											<b-col cols="4" class="p-0"> 
											<video class="vdlList" :id="'mlSource'+itemV.id" :src="$root.MEDIAPATH+'videos/'+itemV.video_url"></video>
											</b-col>
											<b-col>
												<h5 class="mb-1" style="font-size: 13px;">{{itemV.title}}</h5>
												
													<p class="mb-1 p-0" style="line-height: initial;font-size:14px;">
													<small>{{itemV.message}}</small>
													</p>
											</b-col>
										</b-row>
								  </b-list-group-item>
								  
								</b-list-group>

						
						
						</b-tab>
						
						
					  </b-tabs>
		
		
		</b-container>
			
			
			</b-col>
		  </b-row>
		  
			
		
      </b-container>
    </div>
			<!-- ------------ Filter Footer --------------- -->
		<b-container class="mt-2 d-md-none"></b-container>
		<!-- --------------------- -->
		<b-container fluid class="filterTab d-md-none">
					<b-row>
						<b-col 	cols="6" class="p-0 b-r-1px">
						<div class="segment-1">
						<b-link @click="filterCat=1,filterBrand=0,mobilfilterlist=1">
								<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><defs><filter id="565v74wosa" width="105.8%" height="143.8%" x="-2.9%" y="-21.9%" filterUnits="objectBoundingBox"><feOffset dy="-1" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset><feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2"></feGaussianBlur><feColorMatrix in="shadowBlurOuter1" result="shadowMatrixOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"></feColorMatrix><feMerge><feMergeNode in="shadowMatrixOuter1"></feMergeNode><feMergeNode in="SourceGraphic"></feMergeNode></feMerge></filter></defs><g fill="none" fill-rule="evenodd" opacity=".54"><g fill="#001325" fill-rule="nonzero"><g filter="url(#565v74wosa)" transform="translate(-207 -685) translate(0 672)"><g><g><g><path d="M18.533 5c.567 0 1.028.46 1.028 1.028 0 .247-.089.485-.25.672l-4.98 5.773v5.193c0 .332-.16.643-.43.836L11.9 19.935c-.462.33-1.104.224-1.435-.237-.125-.175-.192-.384-.192-.599v-6.625l-5.02-5.771c-.372-.429-.327-1.078.101-1.45C5.541 5.09 5.78 5 6.028 5h12.505zm-5.468 7.841h-1.528v5.797l1.528-1.094V12.84zm4.95-6.576H6.548l4.688 5.39h2.127l4.65-5.39z" transform="translate(195 6) translate(12) translate(0 7)"></path></g></g></g></g></g></g></svg>
								Brands </b-link>
							
							</div> 
						
						</b-col>
						<b-col cols="6" >
							<div class="segment2">
								<b-link @click="filterBrand=1,filterCat=0,mobilfilterlist=1">
								<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><defs><filter id="565v74wosa" width="105.8%" height="143.8%" x="-2.9%" y="-21.9%" filterUnits="objectBoundingBox"><feOffset dy="-1" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset><feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2"></feGaussianBlur><feColorMatrix in="shadowBlurOuter1" result="shadowMatrixOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"></feColorMatrix><feMerge><feMergeNode in="shadowMatrixOuter1"></feMergeNode><feMergeNode in="SourceGraphic"></feMergeNode></feMerge></filter></defs><g fill="none" fill-rule="evenodd" opacity=".54"><g fill="#001325" fill-rule="nonzero"><g filter="url(#565v74wosa)" transform="translate(-207 -685) translate(0 672)"><g><g><g><path d="M18.533 5c.567 0 1.028.46 1.028 1.028 0 .247-.089.485-.25.672l-4.98 5.773v5.193c0 .332-.16.643-.43.836L11.9 19.935c-.462.33-1.104.224-1.435-.237-.125-.175-.192-.384-.192-.599v-6.625l-5.02-5.771c-.372-.429-.327-1.078.101-1.45C5.541 5.09 5.78 5 6.028 5h12.505zm-5.468 7.841h-1.528v5.797l1.528-1.094V12.84zm4.95-6.576H6.548l4.688 5.39h2.127l4.65-5.39z" transform="translate(195 6) translate(12) translate(0 7)"></path></g></g></g></g></g></g></svg>
								Categories </b-link>
								
								</div>
						</b-col>
				</b-row>

			</b-container>


    <!--<top-footer></top-footer>  -->
  </div>
</template>

<script>
import Header from "@/components/header.vue";
//import Footer from "@/components/footer.vue";


import '../assets/category.scss';
//import RangeSlider from 'vue-range-slider';
// you probably need to import built-in style
import 'vue-range-slider/dist/vue-range-slider.css';
import '@/assets/videos.scss';
export default {
  name: "collection-page-cosmetics",
  
	props: {
    WEBURL: { type: String },
		metadata: { type: Object },
	},
	
	beforeCreate: function () {
    document.body.className = "collection-page-cosmetics";
  },
  components: {
    "top-header": Header,
    //"top-footer": Footer,
    
    //RangeSlider,
  },
  mounted(){
		this.initload();
		
	  /* ============Sticky LeftPanel===============*/
	  this.$nextTick(function(){
        window.addEventListener("scroll", function(){
          var navbar = document.getElementById("filterlist")
          var nav_classes = navbar.classList
          if(document.documentElement.scrollTop >= 150) {
            if (nav_classes.contains("shrink") === false) {
              nav_classes.toggle("shrink");
            }
			
          }
          else {
            if (nav_classes.contains("shrink") === true) {
              nav_classes.toggle("shrink");
            }
          }
        })
      })
	  
		
		
	},
  data() {
    return {
		loading: false,
		mobilfilterlist:0,
		videoListUrl: this.$root.WEBAPI+'propertieapi/video-list',
		videoLoadUrl: this.$root.WEBAPI+'propertieapi/video-load',
		likevideoUrl: this.$root.WEBAPI+'propertieapi/likeVideo',
		videoList: [],
		videoCategory: [],
		topCategory: [],
		brandList:[],
		filter_catId:'',
		filter_brandId:'',
		
		videoPlay:[],
		videoLatest:[],
		videoViewed:[],
		videoLikes:[],
		buynow:'',
		totalView:0,
		totalLike:0,
		filterBrand:0,
		filterCat:0,
		
		height: 120,
		width: 220,
		margin: 20,
		
		videosCatname:'',
		
    };
  },
  methods: {
	initload(){
		var self = this;
		var videoId = this.$route.params.videoId;
			self.axios.post(self.videoListUrl, {
				catId: 	 self.filter_catId,
				brandId: self.filter_brandId,
				loadVideo: atob(videoId),
              //accesskey: self.$root.customer_info.access_key,
          }).then(function (response) {
            //console.log(response);
              if(response.data.error == 0 || response.data.error == '0'){
                //console.log(response.data);
                  self.videoList = response.data.result.videoList;
                  self.videoCategory = response.data.result.videoCategory;
                  self.topCategory = response.data.result.topCategory;
                  self.brandList = response.data.result.brandList;
                  
              }else if(response.data.error == 9){
                //self.$root.forceLogout(response.data.message);
              }
          }).catch(function (error) {
              alert(error);
          });
		 self.axios.post(self.videoLoadUrl, {
				catId: 	 self.filter_catId,
				brandId: self.filter_brandId,
				loadVideo: atob(videoId),
              //accesskey: self.$root.customer_info.access_key,
          }).then(function (response) {
            //console.log(response);
              if(response.data.error == 0 || response.data.error == '0'){
                //console.log(response.data);
                  self.videoPlay 	= response.data.result.videoPlay;
                  self.videoLatest 	= response.data.result.videoLatest;
                  self.videoLikes 	= response.data.result.videoLikes;
                  self.videoViewed 	= response.data.result.videoViewed;
                  self.buynow 		= response.data.result.catUrl;
                  self.filter_catId = response.data.result.catvId;
				  
				  self.totalView=Number(self.videoPlay.viewed)+1;
				  self.totalLike=Number(self.videoPlay.liked);
				  self.filter_brandId=self.videoPlay.brand_id;
                
                  
              }else if(response.data.error == 9){
                //self.$root.forceLogout(response.data.message);
              }
          }).catch(function (error) {
              alert(error);
          });
	
	},
	getMyvideo(){
		var self = this;
		self.mobilfilterlist=0;
		self.loading= true;
		self.axios.post(self.videoListUrl, {
				catId: self.filter_catId,
				brandId: self.filter_brandId,
              //accesskey: self.$root.customer_info.access_key,
          }).then(function (response) {
            //console.log(response);
              if(response.data.error == 0 || response.data.error == '0'){
                //console.log(response.data);
                  self.videoList = response.data.result.videoList;
                  self.videoCategory = response.data.result.videoCategory;
                  
              }else if(response.data.error == 9){
                //self.$root.forceLogout(response.data.message);
              }
			  self.loading= false;
          }).catch(function (error) {
              alert(error);
          });
	
	},
	likeVideo(){
		var self = this;
		var videoId = this.$route.params.videoId;
		 self.axios.post(self.likevideoUrl, {
			loadVideo: atob(videoId),
              //accesskey: self.$root.customer_info.access_key,
          }).then(function (response) {
            //console.log(response);
              if(response.data.error == 0 || response.data.error == '0'){
                //console.log(response.data);
				self.totalLike=self.totalLike+1;
              }else if(response.data.error == 9){
                //self.$root.forceLogout(response.data.message);
              }
          }).catch(function (error) {
              alert(error);
          });
	
	},
	videoUrib64(idm) {
			//console.log(idm);
			return btoa(idm);
	}
  },
  metaInfo() {
        //console.log('-------META INFO-------');
		/*return{
			title: this.metadata.title,
			titleTemplate: null, //'%s | vue-meta Example App',
			meta: [
				{ charset: 'utf-8' },
				{ name: 'keywords', content: this.metadata.keywords },
				{ name: 'description', content: this.metadata.description },
				{ name: 'viewport', content: 'width=device-width, initial-scale=1' },
				{ name:'facebook-domain-verification', content: '2okv5b4k146l9790zmzgh73w2fwuaa' }

			]
		}*/
	}
};
</script>

<style scoped lang="scss">

	
</style>